module.exports = __webpack_public_path__ + "img/first.dde66aa0.svg";